import { get } from "lodash-es";
import { Icon } from "@terminus/dqh-web-ui";
import { Avatar } from "antd";
import { useMutation } from "@tanstack/react-query";
import { logout } from "@/services";
import UserAvatarPng from "./avatar.png";
import { useCurrent } from "@/providers";

const styles = {
  logoutButton: {
    fontSize: 13,
    color: "#A5A5A5",
    padding: "5px 0",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    cursor: "pointer",
  },
};

export const UserCard = (props: any) => {
  const { customerInfo, userInfoSelf } = props;
  const { current: userInfo } = useCurrent();
  const { mutate: logoutServer } = useMutation({
    mutationFn: logout,
  });

  const handleLogout = () => {
    logoutServer(
      { id: 1 },
      {
        onSuccess: () => {
          window.location.href = `${process.env.YCX_HOME}`;
        },
      }
    );
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: 176,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: 4,
          height: 46,
        }}
      >
        <Avatar
          size={32}
          src={get(customerInfo, "userAvatar") ?? UserAvatarPng}
        />
        <div
          style={{ marginLeft: 8, display: "flex", flexDirection: "column" }}
        >
          <span
            style={{
              fontSize: 13,
              fontWeight: 500,
              color: "#1D1D1F",
              maxWidth: 130,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {get(userInfo, "account") ||
              "-"}
          </span>
          <span
            style={{
              fontSize: 12,
              fontWeight: 400,
              color: "#777779",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: 120,
            }}
          >
            {get(customerInfo, "comName") ||
              get(userInfo, "mainAccount.attributes.companyName") ||
              "-"}
          </span>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: 4,
          marginTop: 4,
        }}
      >
        <div
          onClick={(e) => {
            e.stopPropagation();
            window.open(`${process.env.YCX_HOME}/buyer/accountInfo`, "_blank");
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "#FFEEE5";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background =
              "linear-gradient(180deg, #FFF1E8 0%, #FCF9F7 100%)";
          }}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            padding: "8px 6px",
            background: "linear-gradient(180deg, #FFF1E8 0%, #FCF9F7 100%)",
            borderRadius: 4,
            width: 83,
            height: 54,
            marginRight: 10,
          }}
        >
          <Icon name="renyuanpeople" size={16} />
          <span
            style={{
              fontSize: 13,
              fontWeight: 400,
              color: "#FF5600",
              marginTop: 4,
            }}
          >
            账号管理
          </span>
        </div>
        <div
          onClick={(e) => {
            e.stopPropagation();
            window.open(`${process.env.YCX_HOME}/buyer/myNoticeList`, "_blank");
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "#FFEEE5";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background =
              "linear-gradient(180deg, #FFF1E8 0%, #FCF9F7 100%)";
          }}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            padding: "8px 6px",
            background: "linear-gradient(180deg, #FFF1E8 0%, #FCF9F7 100%)",
            borderRadius: 4,
            width: 83,
            height: 54,
          }}
        >
          <Icon name="xiaoximessage-one-h7gkbfe6" size={16} />
          <span
            style={{
              fontSize: 13,
              fontWeight: 400,
              color: "#FF5600",
              marginTop: 4,
            }}
          >
            消息中心
          </span>
        </div>
      </div>
      <div
        style={styles.logoutButton}
        onClick={handleLogout}
        onMouseEnter={(e) => {
          e.currentTarget.style.color = "#1D1D1F";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.color = "#A5A5A5";
        }}
      >
        退出当前账号
      </div>
    </div>
  );
};
